<template>
  <Card>
    <div class="hero">
      <div class="check">✓</div>
      <h2 class="hero-title">{{ title }}</h2>
    </div>

    <template #footer>
      <button class="btn btn-primary full" @click="$emit('close')">關閉</button>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Card from './Card.vue'

const props = defineProps<{
  donated?: boolean
  /** 不支援開發票 → 顯示「交易已結束」 */
  noInvoice?: boolean
}>()

defineEmits<{ (e: 'close'): void }>()

const title = computed(() => {
  if (props.noInvoice) return '交易已結束'
  return props.donated ? '已捐贈' : '已開立發票'
})
</script>

<style scoped>
.hero {
  text-align: center;
  padding: 8px 0 16px;
}
.check {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  background: #10b981;
  color: #fff;
  border-radius: 50%;
  font-size: 32px;
  line-height: 56px;
  font-weight: 700;
}
.hero-title {
  margin: 0;
  font-size: 22px;
  color: #111827;
}
.full {
  width: 100%;
}
</style>
